"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _react = _interopRequireDefault(require("react"));
var _recompose = require("../recompose");
var _styled = _interopRequireWildcard(require("../styled"));
var _i18n = require("../i18n");
var _text = require("../text");
var _icons = require("../icons");
var _templateObject, _templateObject2, _ErrorIcon, _FormattedMessage;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var ErrorWrapper = _styled.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  border: 1px solid ", ";\n  margin-bottom: ", ";\n  padding: ", ";\n"])), (0, _styled.prop)('theme.colors.borderPrimary'), (0, _styled.prop)('theme.gutterWidth'), (0, _styled.rem)(30));
var ErrorIcon = (0, _styled.default)(_icons.Icon).attrs(function (props) {
  return {
    type: 'error',
    width: 80,
    height: 80,
    fill: (0, _styled.prop)('theme.colors.alert')(props)
  };
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-bottom: ", ";\n"])), (0, _styled.rem)(30));
var ErrorMessage = function ErrorMessage(_ref) {
  var className = _ref.className,
    title = _ref.title,
    message = _ref.message;
  return /*#__PURE__*/_react.default.createElement(ErrorWrapper, {
    className: className
  }, _ErrorIcon || (_ErrorIcon = /*#__PURE__*/_react.default.createElement(ErrorIcon, null)), /*#__PURE__*/_react.default.createElement(_text.Title, null, title), /*#__PURE__*/_react.default.createElement(_text.Paragraph, null, message));
};
ErrorMessage.defaultProps = {
  className: undefined
};
var enhance = (0, _recompose.compose)(_i18n.injectIntl, (0, _recompose.withProps)(function (_ref2) {
  var title = _ref2.title,
    message = _ref2.message,
    _ref2$name = _ref2.name,
    name = _ref2$name === void 0 ? 'content' : _ref2$name;
  var titleDescriptor = {
    id: 'app.error.title',
    defaultMessage: 'Sorry, an error ocurred when loading your {name}!',
    values: {
      name: /*#__PURE__*/_react.default.createElement(_i18n.FormattedMessage, {
        id: "app.error.sections." + name,
        defaultMessage: name
      })
    }
  };
  var messageDescriptor = {
    id: 'app.error.message',
    defaultMessage: 'Please {refresh} the page or try again later',
    values: {
      refresh: /*#__PURE__*/_react.default.createElement(_text.Link, {
        href: window.location.href,
        onClick: window.location.reload
      }, _FormattedMessage || (_FormattedMessage = /*#__PURE__*/_react.default.createElement(_i18n.FormattedMessage, {
        id: "app.error.refresh",
        defaultMessage: "refresh"
      })))
    }
  };
  return {
    title: title || /*#__PURE__*/_react.default.createElement(_i18n.FormattedMessage, titleDescriptor),
    message: message || /*#__PURE__*/_react.default.createElement(_i18n.FormattedMessage, messageDescriptor)
  };
}));
var _default = exports.default = enhance(ErrorMessage);